import React from "react";
import { Col, ListGroup, Row } from "react-bootstrap";
import { ChevronRight } from "react-bootstrap-icons";
import { NavLink } from "react-router-dom";

export const Home: React.FC = () => {
	return <>
		<Row className="mt-4">
			<Col xs={4}>
				<h6>Gestión de Contenidos</h6>
				<ListGroup className="shadow">
					<ListGroup.Item variant="light" action as={NavLink} to={"contents"} className="d-flex">
						<span className="ms-2 me-auto">Contenidos</span> <ChevronRight />
					</ListGroup.Item>
					<ListGroup.Item variant="light" action as={NavLink} to={"pages"} className="d-flex">
						<span className="ms-2 me-auto">Navegación</span> <ChevronRight />
					</ListGroup.Item>
					<ListGroup.Item variant="light" action as={NavLink} to={"tags"} className="d-flex">
						<span className="ms-2 me-auto">Etiquetas</span> <ChevronRight />
					</ListGroup.Item>
					<ListGroup.Item variant="light" action as={NavLink} to={"templates"} className="d-flex">
						<span className="ms-2 me-auto">Plantillas</span> <ChevronRight />
					</ListGroup.Item>
				</ListGroup>
			</Col>
		</Row>
	</>
}